import Swal from "sweetalert2";

export function showFileNotSelectedAlert() {
  return Swal.fire({
    icon: "error",
    title: "Arquivo não selecionado",
    text: "Por favor, selecione um arquivo para enviar.",
    confirmButtonColor: "#2F855A",
  });
}

export function showProcessingSuccessAlert() {
  return Swal.fire({
    icon: "success",
    title: "Arquivo processado com sucesso",
    text: "Todos os registros foram carregados. Agora você pode confirmar o registro dos dados.",
    timer: 2500,
    timerProgressBar: true,
    showConfirmButton: false,
    confirmButtonColor: "#2F855A",
  });
}

export function showProcessingErrorAlert() {
  return Swal.fire({
    icon: "error",
    title: "Falha no processamento",
    text: "Não foi possível processar o arquivo. Verifique o formato e tente novamente.",
    confirmButtonColor: "#2F855A",
  });
}

export function showRegistrationErrorAlert() {
  return Swal.fire({
    icon: "error",
    title: "Falha no registro",
    text: "Não foi possível completar o registro dos dados. Tente novamente.",
    confirmButtonColor: "#2F855A",
  });
}

export function showErrorRecordsAlert(errorRecords) {
  const errorListHtml = `
    <ul style="text-align: left; max-height: 200px; overflow-y: auto;">
      ${errorRecords
        .map(
          (record, index) =>
            `<li><strong>Linha ${record[0]}</strong>: ${record[1]}</li>`
        )
        .join("")}
    </ul>
  `;

  return Swal.fire({
    icon: "warning",
    title: "Atenção: Registros com erros detectados",
    html: `<p>Foram encontrados ${errorRecords.length} registros não coerentes com o formato esperado no arquivo enviado.</p>
              <p class="mt-2">⚠️ <b>Importante:</b> Estes registros serão desconsiderados no sistema.</p>
           <br/>${errorListHtml}`,
    confirmButtonColor: "#2F855A",
  });
}

export function showInvalidRecordsAlert(invalidRecords) {
  return Swal.fire({
    icon: "warning",
    title: "Atenção: Registros com problemas detectados",
    html: `
      <div class="text-left">
        <p>Foram encontrados <b>${invalidRecords.length} registros</b> com problemas no arquivo.</p>
        <p class="mt-2">⚠️ <b>Importante:</b> Estes registros com problemas <u>não serão incluídos</u> no sistema. 
        Se precisar destes dados, você deve corrigir os erros e enviar novamente.</p>
      </div>
    `,
    showConfirmButton: true,
    showDenyButton: true,
    confirmButtonText: "Continuar assim mesmo",
    denyButtonText: "Ver registros com problemas",
    confirmButtonColor: "#2F855A",
    denyButtonColor: "#4A5568",
  });
}

export function showDataReplacementConfirmation() {
  return Swal.fire({
    title: "Confirmação",
    text: "Os dados existentes serão substituídos. Deseja prosseguir?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sim, continuar",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#2F855A",
    cancelButtonColor: "#9CA3AF",
  });
}

export function showRestartConfirmation() {
  return Swal.fire({
    title: "Tem certeza?",
    text: "Você perderá os dados carregados até o momento. Deseja continuar?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, recomeçar",
    cancelButtonText: "Não, continuar",
    confirmButtonColor: "#2F855A",
    cancelButtonColor: "#9CA3AF",
  });
}
